import { render, staticRenderFns } from "./PendingApplicationBanner.vue?vue&type=template&id=b5665c40&scoped=true"
import script from "./PendingApplicationBanner.vue?vue&type=script&lang=js"
export * from "./PendingApplicationBanner.vue?vue&type=script&lang=js"
import style0 from "./PendingApplicationBanner.vue?vue&type=style&index=0&id=b5665c40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5665c40",
  null
  
)

export default component.exports